const BASE_DOMAIN = '.shinhanx.kz'

export class CookieService {
  static setCookie(name, value, options = {}) {
    const {
      path = '/',
      maxAge,
      domain = BASE_DOMAIN,
      secure = true,
      sameSite = 'Lax'
    } = options

    const cookieParts = [
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
      `path=${path}`,
      domain && `domain=${domain}`,
      maxAge !== undefined && `max-age=${maxAge}`,
      secure && 'secure',
      sameSite && `samesite=${sameSite}`
    ].filter(Boolean)

    document.cookie = cookieParts.join('; ')
  }

  static getCookie(name) {
    const cookies = document.cookie.split('; ')
    const found = cookies.find(c => c.startsWith(`${name}=`))
    return found ? decodeURIComponent(found.split('=')[1]) : null
  }

  static deleteCookieEverywhere(name, paths = ['/', '/credit-flow', '/sign-docs']) {
    paths.forEach(path => {
      const cookieParts = [
        `${encodeURIComponent(name)}=`,
        `path=${path}`,
        `domain=${BASE_DOMAIN}`,
        'max-age=0',
        'secure',
        'samesite=Lax'
      ]
      document.cookie = cookieParts.join('; ')
    })
  }
}
